module.exports = __webpack_public_path__ + "static/drc-seal-3328a4937dc18cbb03c2afaae543d8ee.svg";